import { useState } from "react";
import { Megaphone, TrendingUp, Check, MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const WA = "918605593941";
const CONTENT = {
  advertise: {
    icon: Megaphone, title: "Advertise With CarSaleMarket.com", tagline: "Reach Car Buyers Across India.",
    body: "Promote your Dealership, Showroom, Finance, Insurance, Garage, or Accessories brand on India's Premium Pre-Owned Car Marketplace.",
    listTitle: "What You Get", list: ["Homepage Banner Ads", "Featured Dealer Store", "Top Promoted Listings", "Pan-India Visibility in 36 States & UTs"],
    cta: "To Get Ad Rates & Packages, Contact Owner Directly:", msg: "ADS",
  },
  invest: {
    icon: TrendingUp, title: "Invest In CarSaleMarket.com", tagline: "Be Part of India's Next Big Car Platform.",
    body: "We are building India's Premium Pre-Owned Car Marketplace - connecting buyers directly with private owners and trusted dealers across all 36 States & UTs.",
    listTitle: "Why Invest With Us", list: ["Early-Stage Growth Opportunity", "Pan-India Expansion Plan", "Fast Growing Used-Car Market", "Transparent & Founder-Led"],
    cta: "To Discuss Investment, Contact Founder Directly:", msg: "INVEST",
  },
};

function PromoDialog({ kind, onClose }) {
  const c = CONTENT[kind];
  const Icon = c.icon;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0d0f14] border-[#D4AF37]/40 text-white sm:max-w-lg" data-testid={`${kind}-dialog`}>
        <DialogHeader>
          <span className="w-11 h-11 rounded-full flex items-center justify-center mb-1" style={{ background: "var(--gold-grad)" }}><Icon className="w-5 h-5 text-black" /></span>
          <DialogTitle className="font-display text-3xl gold-text leading-tight">{c.title}</DialogTitle>
          <DialogDescription className="text-white font-semibold text-base">{c.tagline}</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-gray-300">{c.body}</p>
        <div>
          <p className="eyebrow !text-[10px] mb-2">{c.listTitle}</p>
          <ul className="grid sm:grid-cols-2 gap-2">
            {c.list.map((x) => <li key={x} className="flex items-start gap-2 text-sm"><Check className="w-4 h-4 text-[#D4AF37] shrink-0 mt-0.5" />{x}</li>)}
          </ul>
        </div>
        <div className="rounded-xl border gold-line bg-black/40 p-4 space-y-3">
          <p className="text-sm text-gray-300">{c.cta}</p>
          <a href={`https://wa.me/${WA}?text=${c.msg}`} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2 py-3 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-black font-semibold transition-colors" data-testid={`${kind}-whatsapp-btn`}>
            <MessageCircle className="w-4 h-4" /> WhatsApp Now: 8605593941
          </a>
          <p className="text-[11px] text-gray-500 text-center">Message "{c.msg}"</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default function PromoButtons({ className = "", btnClass = "", prefix = "" }) {
  const [open, setOpen] = useState(null);
  const cls = `btn-gold !py-1.5 !px-3 text-xs whitespace-nowrap ${btnClass}`;
  return (
    <div className={`flex gap-2 ${className}`} onClick={(e) => e.stopPropagation()}>
      <button className={cls} onClick={() => setOpen("advertise")} data-testid={`${prefix}advertise-btn`}><Megaphone className="w-3.5 h-3.5" />Advertise With Us</button>
      <button className={cls} onClick={() => setOpen("invest")} data-testid={`${prefix}invest-btn`}><TrendingUp className="w-3.5 h-3.5" />Invest With Us</button>
      {open && <PromoDialog kind={open} onClose={() => setOpen(null)} />}
    </div>
  );
}
